import { useCallback } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { differenceInMilliseconds } from 'date-fns'

import { QUERY_REFETCH_INTERVAL } from 'modules/Monitoring/consts/query/query'
import { QueryKey } from 'modules/Monitoring/consts/query/queryKey'

export const useOutdatedQuery = (queryKey?: QueryKey) => {
  const queryClient = useQueryClient()

  const checkIfQueryIsOutdated = useCallback(() => {
    const queryUpdatedDate = queryClient.getQueryCache().find({
      exact: false,
      type: 'active',
      queryKey: [queryKey],
    })?.state.dataUpdatedAt

    if (!queryUpdatedDate) {
      return false
    }

    return differenceInMilliseconds(Date.now(), queryUpdatedDate) > QUERY_REFETCH_INTERVAL
  }, [queryKey, queryClient])

  return {
    checkIfQueryIsOutdated,
  }
}
